import { parse } from 'query-string';
import { di } from 'react-magnetic-di';
import type { RecordProxy } from 'relay-runtime';

export const setIsViewConfigModifiedRecord = ({
	isViewConfigModified,
	viewRecord,
}: {
	isViewConfigModified: boolean;
	viewRecord: RecordProxy;
}): void => {
	di(globalThis);
	const { groupBy, hideDone, jql } = parse(globalThis.location.search);

	// Updates the isViewConfigModified field that is set when resetting the view
	// We do not provide settings overrides in the reset flow because we want to reset
	// to the last published view settings
	viewRecord.setValue(isViewConfigModified, 'isViewConfigModified');

	// Updates the isViewConfigModified field that is set when preloading the view
	// via hovering over the view's navigation item in the horizontal nav.
	// In this scenario we do not have any settings overrides via query params
	// so we set settings to an empty object
	viewRecord.setValue(isViewConfigModified, 'isViewConfigModified', {
		settings: {},
	});

	// Updates the isViewConfigModified field that is set during the preloaded query
	// The settings provided here match the settings used in the query parameters
	viewRecord.setValue(isViewConfigModified, 'isViewConfigModified', {
		settings: {
			groupBy,
			hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined,
			jql,
		},
	});
};
